export default __webpack_public_path__ + "static/media/icon-back.33b4e27b.svg";